import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITableItem } from 'shared-types/index';
import { ITablesState } from './types';

const initialState: ITablesState = {
  archivedWaitListTables: [],
  hasUserDefinedTables: false
};

const slice = createSlice({
  name: 'tables', // used in action types
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setArchivedWaitListTables: (state: ITablesState, action: PayloadAction<ITableItem[]>) => {
      state.archivedWaitListTables = action.payload;
    },
    setHasUserDefinedTables: (state: ITablesState, action: PayloadAction<boolean>) => {
      state.hasUserDefinedTables = action.payload;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = slice;
// Extract and export each action creator by name
export { actions as tablesActions };
// Export the reducer, either as a default or named export
export default reducer;
